import styled from 'styled-components';

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level4};
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;

  &:fullscreen {
    padding: ${({ theme }) => theme.spacing.level4};
    background: ${({ theme }) => theme.colors.surface};
  }
`;

export const ExitBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.level3};
  flex: 0 0 auto;
`;

export const AreaTitle = styled.h2`
  margin: 0;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.onSurface};
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
